import { Badge, Box, Divider, IconButton, Stack, Typography, useTheme } from "@mui/material";
import PrimaryHoverEffect from "src/components/ui/warehouse/primaryHoverEffect";
import { Suspense, lazy, useContext, useEffect, useState } from "react";
import { SideBarMenuSectionWrapper } from "src/components/ui";
import useGetCheckNewMessage from "../../../services/sidebarDashboard/usefulSection/useGetCheckNewMessage";
import { SideMenuBox } from "../professionalSection/style";
import LoadingComponent from "src/components/ui/loading-component/LoadingComponent";
import useGetNotificationCount from "../../../services/sidebarDashboard/usefulSection/useGetNotificationCount";
import { ArrowRight } from "react-iconly";
import { UserContext } from "src/contexts/UserContext";

const UsefulSection = ({ menu }) => {
  let Icon;
  let ComponentSelected;

  const theme = useTheme();
  const { businessID } = useContext(UserContext);

  const refetchDuration = 600000;

  const [messageCount, setMessageCount] = useState(0);
  const [nofitCount, setNotifCount] = useState(0);

  // const [menuList, setMenuList] = useState([]);
  const [anchorElAI, setAnchorElAI] = useState(null);
  const openAI = Boolean(anchorElAI);

  const [anchorElContactUs, setAnchorElContactUs] = useState(null);
  const openContactUs = Boolean(anchorElContactUs);

  const [anchorElOnlineChat, setAnchorElOnlineChat] = useState(null);
  const openOnlineChat = Boolean(anchorElOnlineChat);

  const [anchorElNotification, setAnchorElNotification] = useState(null);
  const openNotification = Boolean(anchorElNotification);

  // contact Us
  const handleClickAI = (event) => {
    // setAnchorElAI(event?.currentTarget);
  };
  const handleCloseAI = () => setAnchorElAI(null);

  // contact Us
  const handleClickContactUs = (event) => {
    setAnchorElContactUs(event?.currentTarget);
  };
  const handleCloseContactUs = () => setAnchorElContactUs(null);

  // online Chat
  const handleClickOnlineChat = (event) => {
    setSkip(false);
    setAnchorElOnlineChat(event?.currentTarget);
    setMessageCount(0);
  };
  const handleCloseOnlineChat = () => {
    setAnchorElOnlineChat(null);
  };

  // notification
  const handleClickNotification = (event) => {
    setAnchorElNotification(event?.currentTarget);
    setNotifCount(0);
  };
  const handleCloseNotification = () => {
    setAnchorElNotification(null);
  };

  const idAI = openAI ? "simple-popover" : undefined;
  const idContactUs = openContactUs ? "simple-popover" : undefined;
  const idNotification = openNotification ? "simple-popover" : undefined;
  const idOnlineChat = openOnlineChat ? "simple-popover" : undefined;
  const [skip, setSkip] = useState(true);
  const { data, error, loading, refetch } = useGetCheckNewMessage(skip);

  const menuList = menu;

  const {
    loading: loadingCount,
    error: errorCount,
    data: dataCount,
    refetch: refetchCount,
  } = useGetNotificationCount(
    businessID,
    "S.AVC.AVC.CommonMenus.Notifications.notificationCount.Full",
    !menuList[0]?.node?.subMenus?.edges?.findIndex((i) => i?.node?.name === "اعلانات")
  );
  let timer = null;

  useEffect(() => {
    setMessageCount(data?.checkNewMessage?.count);
    setNotifCount(dataCount?.notificationCount);
    if (!anchorElOnlineChat) {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      // timer = setInterval(refetch, refetchDuration);
    } else {
      clearInterval(timer);
      timer = null;
    }
    return () => clearInterval(timer);
  }, [menu, anchorElOnlineChat, dataCount, data]);

  if (menuList.length === 0) return <Divider sx={{ borderColor: "primary.main", my: 1, borderWidth: 2 }} />;
  if (menuList.length > 0)
    return (
      <Stack justifyContent={"center"} alignItems={"center"} gap={1}>
        {menuList[0]?.node?.subMenus?.edges?.findIndex((i) => i?.node?.name === "دستیار هوشمند") !== -1 && (
          <Box height={40} borderRadius={10} width={40}>
            <PrimaryHoverEffect className={openAI ? "active" : ""}>
              <Suspense fallback={<LoadingComponent open={true} title="لطفا منتظر بمانید ..." />}>
                {
                  (Icon = lazy(
                    () =>
                      import(
                        "src/components/ui/svgIcon/" +
                          menuList[0]?.node?.subMenus?.edges[
                            menuList[0]?.node?.subMenus?.edges?.findIndex((i) => i?.node?.name === "دستیار هوشمند")
                          ].node?.icon
                      )
                  ))
                }
                <IconButton onClick={handleClickAI}>
                  <Icon color={theme.palette.text.primary} />
                </IconButton>
              </Suspense>
            </PrimaryHoverEffect>
          </Box>
        )}

        {menuList[0]?.node?.subMenus?.edges?.findIndex((i) => i?.node?.name === "راه‌های ارتباطی") !== -1 && (
          <Box height={38} width={50}>
            <PrimaryHoverEffect className={openContactUs ? "active" : ""}>
              <Suspense fallback={<LoadingComponent open={true} title="لطفا منتظر بمانید ..." />}>
                {
                  (Icon = lazy(
                    () =>
                      import(
                        "src/components/ui/svgIcon/" +
                          menuList[0]?.node?.subMenus?.edges[
                            menuList[0]?.node?.subMenus?.edges?.findIndex((i) => i?.node?.name === "راه‌های ارتباطی")
                          ].node?.icon
                      )
                  ))
                }
                <IconButton onClick={handleClickContactUs}>
                  <Icon fontSize="small" color={theme.palette.text.primary} />
                </IconButton>
              </Suspense>
            </PrimaryHoverEffect>
          </Box>
        )}

        {menuList[0]?.node?.subMenus?.edges?.findIndex((i) => i?.node?.name === "گفتگوی آنلاین") !== -1 && (
          <Box height={40} borderRadius={10} width={40}>
            <PrimaryHoverEffect className={openOnlineChat ? "active" : ""}>
              {messageCount !== 0 ? (
                <Suspense fallback={<LoadingComponent open={true} title="لطفا منتظر بمانید ..." />}>
                  {
                    (Icon = lazy(
                      () =>
                        import(
                          "src/components/ui/svgIcon/" +
                            menuList[0]?.node?.subMenus?.edges[
                              menuList[0]?.node?.subMenus?.edges?.findIndex((i) => i?.node?.name === "گفتگوی آنلاین")
                            ].node?.icon
                        )
                    ))
                  }
                  <IconButton onClick={handleClickOnlineChat}>
                    <Badge
                      badgeContent={messageCount}
                      color="primary"
                      anchorOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                    >
                      <Icon fontSize="small" color={theme.palette.text.primary} />
                    </Badge>
                  </IconButton>
                </Suspense>
              ) : (
                <Suspense fallback={<LoadingComponent open={true} title="لطفا منتظر بمانید ..." />}>
                  {
                    (Icon = lazy(
                      () =>
                        import(
                          "src/components/ui/svgIcon/" +
                            menuList[0]?.node?.subMenus?.edges[
                              menuList[0]?.node?.subMenus?.edges?.findIndex((i) => i?.node?.name === "گفتگوی آنلاین")
                            ].node?.icon
                        )
                    ))
                  }
                  <IconButton onClick={handleClickOnlineChat}>
                    <Badge
                      badgeContent={messageCount}
                      color="primary"
                      anchorOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                    >
                      <Icon fontSize="small" color={theme.palette.text.primary} />
                    </Badge>
                  </IconButton>
                </Suspense>
              )}
            </PrimaryHoverEffect>
          </Box>
        )}

        {menuList[0]?.node?.subMenus?.edges?.findIndex((i) => i?.node?.name === "اعلانات") !== -1 && (
          <Box height={40} borderRadius={10} width={40}>
            <PrimaryHoverEffect className={openNotification ? "active" : ""}>
              {nofitCount !== 0 ? (
                <Suspense fallback={<LoadingComponent open={true} title="لطفا منتظر بمانید ..." />}>
                  {
                    (Icon = lazy(
                      () =>
                        import(
                          "src/components/ui/svgIcon/" +
                            menuList[0]?.node?.subMenus?.edges[
                              menuList[0]?.node?.subMenus?.edges?.findIndex((i) => i?.node?.name === "اعلانات")
                            ].node?.icon
                        )
                    ))
                  }
                  <IconButton onClick={handleClickNotification}>
                    <Badge
                      badgeContent={nofitCount}
                      color="primary"
                      anchorOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                    >
                      <Icon fontSize="small" color={theme.palette.text.primary} />
                    </Badge>
                  </IconButton>
                </Suspense>
              ) : (
                <Suspense fallback={<LoadingComponent open={true} title="لطفا منتظر بمانید ..." />}>
                  {
                    (Icon = lazy(
                      () =>
                        import(
                          "src/components/ui/svgIcon/" +
                            menuList[0]?.node?.subMenus?.edges[
                              menuList[0]?.node?.subMenus?.edges?.findIndex((i) => i?.node?.name === "اعلانات")
                            ].node?.icon
                        )
                    ))
                  }
                  <IconButton onClick={handleClickNotification}>
                    <Icon fontSize="small" color={theme.palette.text.primary} />
                  </IconButton>
                </Suspense>
              )}
            </PrimaryHoverEffect>
          </Box>
        )}

        {/* AI */}

        <SideMenuBox
          id={idAI}
          open={openAI}
          anchorEl={anchorElAI}
          onClose={handleCloseAI}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
        >
          <Stack alignItems="center" justifyContent="center" height="100%" width="100%">
            <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%" my={2}>
              <IconButton onClick={handleCloseAI}>
                <ArrowRight color="grey.bg" size={30} />
              </IconButton>
              <Typography variant="h6" fontWeight="fontWeightMedium">
                دستیار هوشمند
              </Typography>
              <Stack width={60} />
            </Stack>

            <SideBarMenuSectionWrapper>
              <Suspense fallback={<LoadingComponent open={true} title="لطفا منتظر بمانید ..." />}>
                {
                  (ComponentSelected = lazy(
                    () =>
                      import(
                        "src/layouts/" +
                          menuList[0]?.node?.subMenus?.edges[
                            menuList[0]?.node?.subMenus?.edges?.findIndex((i) => i?.node?.name === "دستیار هوشمند")
                          ].node?.codeInWeb
                      )
                  ))
                }
                <ComponentSelected></ComponentSelected>
              </Suspense>
              {/* <CommunicationWays /> */}
            </SideBarMenuSectionWrapper>
          </Stack>
        </SideMenuBox>

        {/* contact us */}
        <SideMenuBox
          id={idContactUs}
          open={openContactUs}
          anchorEl={anchorElContactUs}
          onClose={handleCloseContactUs}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
        >
          <Stack alignItems="center" justifyContent="center" height="100%" width="100%">
            <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%" my={2}>
              <IconButton onClick={handleCloseContactUs}>
                <ArrowRight color="grey.bg" size={30} />
              </IconButton>
              <Typography variant="h6" fontWeight="fontWeightMedium">
                راه‌های ارتباطی
              </Typography>
              <Stack width={60} />
            </Stack>

            <SideBarMenuSectionWrapper>
              <Suspense fallback={<LoadingComponent open={true} title="لطفا منتظر بمانید ..." />}>
                {
                  (ComponentSelected = lazy(
                    () =>
                      import(
                        "src/features/" +
                          menuList[0]?.node?.subMenus?.edges[
                            menuList[0]?.node?.subMenus?.edges?.findIndex((i) => i?.node?.name === "راه‌های ارتباطی")
                          ].node?.codeInWeb
                      )
                  ))
                }
                <ComponentSelected></ComponentSelected>
              </Suspense>
              {/* <CommunicationWays /> */}
            </SideBarMenuSectionWrapper>
          </Stack>
        </SideMenuBox>

        {/* notification */}
        <SideMenuBox
          id={idNotification}
          open={openNotification}
          anchorEl={anchorElNotification}
          onClose={handleCloseNotification}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
        >
          <Stack alignItems="center" justifyContent="center" height="100%" width="100%">
            <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%" my={2}>
              <IconButton onClick={handleCloseNotification}>
                <ArrowRight color="grey.bg" size={30} />
              </IconButton>
              <Typography variant="h6" fontWeight="fontWeightMedium">
                اعلانات
              </Typography>
              <Stack width={60} />
            </Stack>

            <SideBarMenuSectionWrapper>
              <Suspense fallback={<LoadingComponent open={true} title="لطفا منتظر بمانید ..." />}>
                {
                  (ComponentSelected = lazy(
                    () =>
                      import(
                        "src/layouts/" +
                          menuList[0]?.node?.subMenus?.edges[
                            menuList[0]?.node?.subMenus?.edges?.findIndex((i) => i?.node?.name === "اعلانات")
                          ].node?.codeInWeb
                        // "src/layouts/AVC_Main/components/sidebarDashboard/usefulSection/notification/NotifAccardion"
                        //  "src/layouts/" +
                        //   menuList[0]?.node?.subMenus?.edges[
                        //     menuList[0]?.node?.subMenus?.edges?.findIndex((i) => i?.node?.name === "اعلانات")
                        //   ].node?.codeInWeb
                      )
                  ))
                }
                <ComponentSelected></ComponentSelected>
              </Suspense>
              {/* <VeiwNotif /> */}
            </SideBarMenuSectionWrapper>
          </Stack>
        </SideMenuBox>

        {/*  online chat */}
        <SideMenuBox
          id={idOnlineChat}
          open={openOnlineChat}
          anchorEl={anchorElOnlineChat}
          onClose={handleCloseOnlineChat}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
        >
          <Stack alignItems="center" justifyContent="start" height="100%" width="100%">
            <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%" my={2}>
              <IconButton onClick={handleCloseOnlineChat}>
                <ArrowRight color="grey.bg" size={30} />
              </IconButton>
              <Typography variant="h6" fontWeight="fontWeightMedium" sx={{ m: "0 auto" }}>
                گفتگو آنلاین
              </Typography>
              <Stack width={60} />
            </Stack>

            <SideBarMenuSectionWrapper>
              <Suspense fallback={<LoadingComponent open={true} title="لطفا منتظر بمانید ..." />}>
                {
                  (ComponentSelected = lazy(
                    () =>
                      import(
                        "src/features/" +
                          menuList[0]?.node?.subMenus?.edges[
                            menuList[0]?.node?.subMenus?.edges?.findIndex((i) => i?.node?.name === "گفتگوی آنلاین")
                          ].node?.codeInWeb
                      )
                  ))
                }
                <ComponentSelected handleClickOnlineChat={handleClickOnlineChat}></ComponentSelected>
              </Suspense>
              {/* <OnlineChat handleClickOnlineChat={handleClickOnlineChat} /> */}
            </SideBarMenuSectionWrapper>
          </Stack>
        </SideMenuBox>

        <Stack
          sx={{ borderColor: "primary.main", my: 1, borderRadius: 2 }}
          width={30}
          bgcolor={"primary.light"}
          height={2}
        />
      </Stack>
    );
};

export default UsefulSection;
